module.exports = __webpack_public_path__ + "img/moon_ios_802.png";